import load from '#core/load';


const ready_attr = 'content-ready';
const loaded_attr = 'content-loaded';


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('animation')) return false;
		
		load.content(() => {
			document.documentElement.setAttribute(ready_attr, '');
		});
		load.all(() => {
			document.documentElement.setAttribute(loaded_attr, '');
		});
	},
	
};

export default module;
module.init();
